export default __webpack_public_path__ + "static/media/6-1820x480冷链果汁.308e970c.jpg";